import {Component, OnInit} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {FieldConfig} from "../../../interfaces/field.interface";

@Component({
  selector: "app-date",
  template: `
      <span class="{{field.name}}-dynamic-class">
        <mat-form-field class="demo-full-width margin-top" [formGroup]="group">
          <mat-label>{{field.label}}</mat-label>
          <input matInput [matDatepicker]="picker" [formControlName]="field.name">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-hint></mat-hint>
          @for (validation of field.validations; track validation) {
            <ng-container ngProjectAs="mat-error">
              @if (group.get(field.name).hasError(validation.name)) {
                <mat-error>{{validation.message}}</mat-error>
              }
            </ng-container>
          }
        </mat-form-field>
      </span>
      
      `,
  styles: []
})
export class DateComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;

  constructor() {
  }

  ngOnInit() {
  }
}
